import LoadingPage from "@components/Loader/LoadingPage";
import {
  EventDetailComponentType,
  EventDetailComponentTypes,
  EventType,
  NFTEvent,
} from "@models/event";
import { useUserStore } from "@providers/auth";
import { EventDetail, usePaymentStore } from "@providers/checkout";
import { EventPageProps, getEventServerSide } from "@providers/checkout/event";
import Layout from "components/Layout/Layout";
import type { NextPage } from "next";
import { useEffect } from "react";

const FALLBACK_URL = "https://clubdao.moongate.id";

export const getServerSideProps = getEventServerSide;

const BENEFIT_EVENT_DETAIL_COMPONENTS_ORDER: EventDetailComponentType[] = [
  EventDetailComponentTypes.info,
  EventDetailComponentTypes.ticketType,
  EventDetailComponentTypes.eligibility,
  EventDetailComponentTypes.about,
  EventDetailComponentTypes.hostInfo,
  EventDetailComponentTypes.aboutMoongate,
  EventDetailComponentTypes.faqLink,
];

const TICKET_EVENT_DETAIL_COMPONENTS_ORDER: EventDetailComponentType[] = [
  EventDetailComponentTypes.generalInfo,
  EventDetailComponentTypes.about,
  EventDetailComponentTypes.ticketType,
  EventDetailComponentTypes.ticketInfo,
  EventDetailComponentTypes.aboutMoongate,
  EventDetailComponentTypes.faqLink,
];

const MEMBERSHIP_EVENT_DETAIL_COMPONENTS_ORDER: EventDetailComponentType[] = [
  EventDetailComponentTypes.info,
  EventDetailComponentTypes.ticketType,
  EventDetailComponentTypes.eligibility,
  EventDetailComponentTypes.about,
  EventDetailComponentTypes.hostInfo,
  EventDetailComponentTypes.aboutMoongate,
  EventDetailComponentTypes.faqLink,
];

const returnEventDetailComponentsOrder = (event: NFTEvent) => {
  switch (event.type) {
    case EventType.BENEFIT:
      return BENEFIT_EVENT_DETAIL_COMPONENTS_ORDER;
    case EventType.MEMBERSHIP:
      return MEMBERSHIP_EVENT_DETAIL_COMPONENTS_ORDER;
    default:
    case EventType.TICKET:
      return TICKET_EVENT_DETAIL_COMPONENTS_ORDER;
  }
};

const Event: NextPage<EventPageProps> = ({
  eventParams,
  title,
  description,
  image,
  url,
}) => {
  const user = useUserStore((state) => state.user);
  const event = usePaymentStore((state) => state.event);
  const _event = new NFTEvent(eventParams || {});

  useEffect(() => {
    if (!_event?.id) return;
    console.log("event data", _event, title, description, image, url);
    usePaymentStore.setState({ event: _event });
  }, []);

  if (!eventParams) {
    window.location.href = FALLBACK_URL;
    return;
  }

  return (
    <>
      {event?.id ? (
        <Layout>
          <EventDetail
            event={event}
            user={user}
            showContactUs={false}
            actionButtonStyles={{
              base: "flex flex-row justify-center items-center flex-grow w-full relative border-2 last:border-0 text-center font-semibold first:rounded-bl-xl last:rounded-br-xl cursor-pointer shadow-lg ",
              disabled: "bg-neutral-600",
              fill: "last:bg-[#9C7B64]",
            }}
            dateTimeLocationContainerClassName="flex flex-col md:flex-row gap-6 mb-4 bg-primary-50 dark:backdrop-blur rounded-lg p-4 w-full dark:bg-transparent"
            dateTimeLocationIconClassName="dark:bg-white rounded"
            dateTimeLocationIconContainerClassName="dark:text-black"
            infoNameClassName="event-detail-info-name"
            componentsOrder={returnEventDetailComponentsOrder(event)}
            showDivider={true}
            showBackButton={false}
          />
        </Layout>
      ) : (
        <LoadingPage title={title} />
      )}
    </>
  );
};
export default Event;
